import axios from 'axios'
import { message } from '@/plugins/message'
import Store from '@/store/index'
// import * as Sentry from '@sentry/vue'

const _axios = axios.create()

const baseHost = process.env.VUE_APP_BASE_API

_axios.defaults.timeout = 300000
_axios.defaults.baseURL = baseHost
_axios.defaults.withCredentials = true
_axios.defaults.responseType = 'json'
_axios.defaults.headers.common['Cache-Control'] = 'no-cache'
_axios.defaults.headers.get['If-Modified-Since'] = '0'
_axios.defaults.cache = false
// 请求拦截器
_axios.interceptors.request.use(
  (config) => {
    // 每次发送请求前，判断vuex中是否存在token，如果存在，则在header头上带上token信息
    const token = Store.state.user.userToken
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error.response)
  }
)

// 响应拦截器
_axios.interceptors.response.use(
  (response) => {
    localStorage.setItem('xAnalysisTypeSearch', JSON.stringify(response.headers['x-analysis-type-search']))
    if (response.data.code === 'authentication.failed') {
      message.error('登录失效了，请重新登录')
      Store.commit('user/setUser', {})
      Store.commit('user/setUserToken', null)
      return Promise.reject(response.data)
    } else if (response.data.code !== 'success') {
      // // 手动上报接口错误信息给sentry
      // const err = new Error(JSON.stringify(response.data))
      // err.name = 'API Error'
      // Sentry.captureException(err, {
      //   extra: response
      // })
      return Promise.reject(response.data)
    } else {
      return response.data.data
    }
  },
  (error) => {
    // // 手动上报接口错误信息给sentry
    // error.name = 'API Status Error'
    // Sentry.captureException(error, {
    //   extra: error.response
    // })
    return Promise.reject(error.response)
  }
)

export class Http {
  static send(config) {
    const configs = Object.assign({
      headers: {},
      timeout: 30000
    }, config)
    return _axios(configs).then((res) => {
      return res
    }).catch((error) => {
      throw error
    })
  }

  static post(url, params = {}, configObj = {}, headers = {}) {
    const config = {
      method: 'post',
      url,
      data: params,
      headers: headers,
      ...configObj
    }
    if (typeof params === 'string') {
      config.headers['Content-Type'] = 'text/plain'
    }
    return Http.send(config)
  }

  static put(url, params = {}, configObj = {}) {
    const config = {
      method: 'put',
      url,
      data: params,
      ...configObj
    }
    return Http.send(config)
  }

  static patch(url, params = {}, configObj = {}) {
    const config = {
      method: 'patch',
      url,
      data: params,
      ...configObj
    }
    return Http.send(config)
  }

  static get(url, params = {}, configObj = {}) {
    let urlParams = []
    Object.keys(params).forEach((k) => {
      // 如果值为空则不传值
      if (params[k] || params[k] === 0 || params[k] === false) {
        urlParams.push(`${k}=${encodeURIComponent(params[k])}`)
      }
    })
    if (urlParams.length) {
      urlParams = `${url}?${urlParams.join('&')}`
    } else {
      urlParams = url
    }
    const config = {
      method: 'get',
      url: urlParams,
      params: {
        randomTime: new Date().getTime()
      },
      ...configObj
    }
    return Http.send(config)
  }

  static delete(url, data, params, configObj = {}) {
    const config = {
      method: 'delete',
      url,
      data,
      params,
      ...configObj
    }
    return Http.send(config)
  }
}

export default {
  install: (Vue) => {
    Vue.prototype.$axios = _axios
  },

  inject: (Store) => {
    Store.prototype.$axios = _axios
  },
  _axios
}
